var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 19.25c.156 0 .313-.04.43-.156l5.625-5.625a.662.662 0 000-.899.662.662 0 00-.899 0l-4.531 4.57V6.126c0-.313-.313-.625-.625-.625a.642.642 0 00-.625.625v11.016l-4.57-4.57a.662.662 0 00-.899 0 .662.662 0 000 .898l5.625 5.625c.117.117.274.156.469.156zm8.75 3.125v-3.75c0-.313-.313-.625-.625-.625a.642.642 0 00-.625.625v3.75c0 1.055-.86 1.875-1.875 1.875H9.125a1.851 1.851 0 01-1.875-1.875v-3.75c0-.313-.313-.625-.625-.625a.642.642 0 00-.625.625v3.75C6 24.133 7.367 25.5 9.125 25.5h11.25a3.11 3.11 0 003.125-3.125z",
    fill: "#34C759"
  })));
}
export default SvgBuy;